import { PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';
import { TrashIcon } from '@/assets/icons';
import { cn } from '@/libs/utils';
import { useCompanyGeneralDataForm } from '../CompanyGeneralDataFormContext';

/** E-mail receivers list. */
export default function CompanyEmailReceiversFields() {
  const {
    emailReceiversKeys,
    emailReceiversState,
    isProfile,
    sectionClass,
    t,
  } = useCompanyGeneralDataForm();

  return (
    <div className={sectionClass('kontakt')}>
      {emailReceiversState?.visible && (
        <>
          {!isProfile && <hr className="mb-5" />}

          <Form.List name={emailReceiversKeys}>
            {(fields, { add, remove }) => (
              <>
                <label className="mb-4 block font-medium text-gray-700">
                  {t('recipientEmail', { ns: 'forms' })}
                </label>

                {fields.map(({ key, name, ...restField }) => (
                  <div key={key} className="mb-2 flex items-start gap-2">
                    <Form.Item
                      {...restField}
                      name={name}
                      rules={[
                        {
                          required: false,
                          message: t('formValidation.emailRequired', {
                            ns: 'forms',
                          }),
                        },
                        {
                          type: 'email',
                          message: t('formValidation.emailInvalid', {
                            ns: 'forms',
                          }),
                        },
                      ]}
                      className="flex-grow"
                    >
                      <Input
                        placeholder={t('email', { ns: 'forms' })}
                        disabled={emailReceiversState?.disabled}
                      />
                    </Form.Item>

                    <Button
                      type="text"
                      title={t('remove')}
                      onClick={() => remove(name)}
                      icon={<TrashIcon />}
                      disabled={emailReceiversState?.disabled}
                      className={cn(
                        'btn-default-action h-8 w-8 !bg-red-500 text-white hover:!text-white'
                      )}
                    >
                      <span className="sr-only">
                        {t('remove', { ns: 'menus' })}
                      </span>
                    </Button>
                  </div>
                ))}

                <Button
                  type="button"
                  onClick={() => add()}
                  className="btn-default mb-4 w-full rounded-[4px] border !border-zinc-200 font-semibold"
                  icon={<PlusOutlined />}
                  disabled={emailReceiversState?.disabled}
                >
                  {t('addEmail', { ns: 'forms' })}
                </Button>
              </>
            )}
          </Form.List>
        </>
      )}
    </div>
  );
}
